import React from 'react';

interface StepBusinessSizeProps {
    formData: {
        businessSize: 'single' | 'franchise';
    };
    updateFormData: (data: { businessSize: 'single' | 'franchise' }) => void;
    onNext: () => void;
    onBack: () => void;
    error: string | null;
}

const StepBusinessSize: React.FC<StepBusinessSizeProps> = ({
    formData,
    updateFormData,
    onNext,
    onBack,
    error
}) => {
    const handleSelect = (size: 'single' | 'franchise') => {
        updateFormData({ businessSize: size });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onNext();
    };

    const options = [
        {
            id: 'single' as const,
            label: 'Estabelecimento único',
            description: 'Apenas uma unidade do negócio'
        },
        {
            id: 'franchise' as const,
            label: 'Rede ou Franquia',
            description: 'Múltiplas unidades ou franquias'
        }
    ];

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="text-center mb-8">
                <p className="text-sm text-primary font-medium mb-2">Informações adicionais</p>
                <h2 className="text-2xl font-bold text-gray-900">Tamanho do negócio</h2>
            </div>

            {error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {error}
                </div>
            )}

            <div className="space-y-3">
                {options.map((option) => (
                    <button
                        key={option.id}
                        type="button"
                        onClick={() => handleSelect(option.id)}
                        className={`
                            w-full flex items-center p-4 rounded-xl border-2 transition-all hover:shadow-md text-left
                            ${formData.businessSize === option.id
                                ? 'border-primary bg-primary/5'
                                : 'border-gray-200 hover:border-gray-300'
                            }
                        `}
                    >
                        <div className={`
                            w-6 h-6 rounded-full border-2 mr-4 flex items-center justify-center flex-shrink-0
                            ${formData.businessSize === option.id
                                ? 'border-primary bg-primary'
                                : 'border-gray-300'
                            }
                        `}>
                            {formData.businessSize === option.id && (
                                <span className="material-symbols-outlined text-white text-sm">check</span>
                            )}
                        </div>
                        <div>
                            <span className="font-medium text-gray-900">{option.label}</span>
                            <p className="text-sm text-gray-500">{option.description}</p>
                        </div>
                    </button>
                ))}
            </div>

            <button
                type="submit"
                className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-semibold rounded-xl transition-all shadow-sm"
            >
                Continuar
            </button>
        </form>
    );
};

export default StepBusinessSize;
